import { esp_text } from "./esp.js";
import { eng_text } from "./eng.js";

let text_lang;

switch (navigator.language || navigator.userLanguage) {
  case "es":
    text_lang = esp_text;
    break;
  case "en":
    text_lang = eng_text;
    break;
  default:
    text_lang = eng_text;
}

export default text_lang;
